import { environment } from '../../util/Environment';
import { apiSlice } from '../store/Api';
import { IUserResponseDto } from './Profile.model';

export const profileApi = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      getUserById: builder.mutation<IUserResponseDto, string>({
        query(userId) {
          return {
            url: `${environment.apiUrl.security}/user/${userId}`,
            method: 'GET',
            headers: {Authorization: `Bearer ${localStorage.getItem('idToken')}`},
          }
        },
      }),
    }
  },
});

export const {useGetUserByIdMutation} = profileApi
